import { Pipe, PipeTransform } from '@angular/core';
import { _tr } from '@app/extensions';

@Pipe({
  name: 'ngFieldName',
})
export class FieldNamePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    let fieldName;

    switch (value.toLowerCase()) {
      case 'signature':
        fieldName = _tr('Signature');
        break;
      case 'initials':
        fieldName = _tr('Initials');
        break;
      case 'checkbox':
        fieldName = _tr('Check Box');
        break;
      case 'radiobutton':
        fieldName = _tr('Radio Button');
        break;
      case 'textinput':
        fieldName = _tr('Text field');
        break;
      case 'dropdown':
        fieldName = _tr('List');
        break;

      case 'title':
        fieldName = _tr("Signer's Title");
        break;

      case 'company':
        fieldName = _tr("Signer's Company");
        break;

      case 'name':
        fieldName = _tr("Signer's Name");
        break;

      case 'email':
        fieldName = _tr("Signer's E-Mail");
        break;

      case 'date':
        fieldName = _tr('Signing Date');
        break;

      default:
        fieldName = value.charAt(0).toUpperCase() + value.substr(1).toLowerCase();
    }

    return fieldName;
  }
}
